import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://krushnakulkarni.com'
      target='_blank'
      rel='noreferrer'
      className='link footer__link'
    >
      Created By Krushna Kulkarni
    </a>
  </footer>
)

export default Footer
